export default "__VITE_ASSET__DGQa1F4s__"